import React, { useRef } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import Layout from "components/layouts/Layout";
import GlobalStyles from "../styles/GlobalStyles";
import TwoColumnWithImage from "components/testimonials/TwoColumnWithImage";

// --- Simple TwoColWithSteps Implementation (delete if you have your own) ---
const StepsContainer = tw.div`w-full bg-gray-100 py-12`;
const StepsInner = tw.div`max-w-5xl mx-auto flex flex-col md:flex-row items-center gap-8 px-4`;
const StepsImage = tw.img`w-full md:w-1/2 rounded-lg shadow-lg`;
const StepsContent = tw.div`flex-1`;
const StepsHeading = tw.h3`text-2xl font-bold mb-4`;
const StepsSubheading = tw.p`text-gray-600 mb-2`;
const StepsList = tw.ol`list-decimal ml-6 space-y-3`;

function TwoColWithSteps({
  subheading,
  heading,
  imageSrc,
  imageDecoratorBlob,
  steps,
}) {
  return (
    <StepsContainer>
      <StepsInner>
        <StepsImage src={imageSrc} alt="Steps" />
        <StepsContent>
          <StepsSubheading>{subheading}</StepsSubheading>
          <StepsHeading>{heading}</StepsHeading>
          <StepsList>
            {steps.map((step, idx) => (
              <li key={idx}>
                <span className="font-semibold">{step.heading}: </span>
                {step.description}
              </li>
            ))}
          </StepsList>
        </StepsContent>
      </StepsInner>
    </StepsContainer>
  );
}

// --- Upside of alumnistories section ---
const UpsideContainer = tw.div`w-full bg-gray-100`;
const Banner = tw.div`w-full h-48 bg-gray-300 flex items-center justify-center`;
const BannerImage = styled.div`
  width: 180px;
  height: 180px;
  background: #e2e8f0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ContentSection = styled.div`
  ${tw`w-full flex flex-col md:flex-row bg-white p-8`}
  max-width: 1200px;
  margin: 0 auto;
`;
const LeftColumn = tw.div`flex-1 flex flex-col justify-center`;
const UpsideHeading = tw.h2`text-lg md:text-xl font-bold mb-2 text-gray-900`;
const UpsideParagraph = tw.p`text-gray-700 mb-4`;
const BulletListsRow = tw.div`flex gap-8 mb-2`;
const BulletList = tw.ul`list-disc list-inside text-gray-700 flex-1`;
const UpsideButton = tw.button`mt-4 px-6 py-2 bg-gray-800 text-white rounded-lg font-semibold`;

const RightColumn = tw.div`flex-1 flex flex-col items-center justify-center`;
const CirclesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 48px);
  grid-template-rows: repeat(3, 48px);
  gap: 16px;
  justify-content: center;
  align-items: center;
`;
const Circle = styled.div`
  width: 48px;
  height: 48px;
  border: 2px solid #cbd5e1;
  border-radius: 50%;
  background: #fff;
`;

// --- Steps with Image Section Data ---
const steps = [
  {
    heading: "Register",
    description: "Create an account with us using Google or Facebook.",
  },
  {
    heading: "Download",
    description:
      "Browse and Download the template that you like from the marketplace.",
  },
  {
    heading: "Run",
    description:
      "Follow the instructions to setup and customize the template to your needs.",
  },
];

// --- Last Box: Upload Student Photos ---
const UploadSection = styled.div`
  ${tw`w-full max-w-6xl mx-auto bg-white rounded-lg shadow-lg mt-8 px-6 md:px-12 py-16 flex flex-col items-center justify-center`}
  min-height: 320px;
`;

const UploadLabel = tw.label`block mb-4 text-lg font-semibold text-gray-800`;
const UploadButton = tw.button`px-6 py-2 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition`;
const FileInput = styled.input`
  display: none;
`;

export default function AlumniPage() {
  const fileInputRef = useRef();

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    // You can handle file upload here (send to backend, preview, etc.)
    const file = event.target.files[0];
    if (file) {
      alert(`Selected file: ${file.name}`);
      // TODO: Upload to backend or show preview
    }
  };

  return (
    <>
      <GlobalStyles />
      <Layout>
        {/* Existing alumni stories section */}
        <TwoColumnWithImage />
      </Layout>
    </>
  );
}
